module.exports = __webpack_public_path__ + "img/wxpub.b8b43e9e.png";